import { render, staticRenderFns } from "./AnxSelect.vue?vue&type=template&id=a1c0af30&scoped=true&"
import script from "./AnxSelect.vue?vue&type=script&lang=ts&"
export * from "./AnxSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AnxSelect.vue?vue&type=style&index=0&id=a1c0af30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0af30",
  null
  
)

export default component.exports